import * as Actions from "./constants";
const initialState = {
  companyList: [],
  deleteCompanySuccess: false,
  updateCompanySuccess: false,
  createCompanySuccess: false,
  companyError: false,
  createCompanyError: false,
};

export default function companyReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.CREATE_COMPANY:
      return {
        ...state,
        createCompanySuccess: false,
        createCompanyError: false,
      };
    case Actions.CREATE_COMPANY_SUCCESS:
      return {
        ...state,
        createCompanySuccess: true,
        createCompanyError: false,
      };
    case Actions.CREATE_COMPANY_ERROR:
      return {
        ...state,
        createCompanySuccess: false,
        error: action.error,
        createCompanyError: true,
      };
    case Actions.GET_ALL_COMPANY:
      return {
        ...state,
      };
    case Actions.GET_ALL_COMPANY_SUCCESS:
      return {
        ...state,
        companyList: action.payload,
      };
    case Actions.GET_ALL_COMPANY_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case Actions.DELETE_COMPANY:
      return {
        ...state,
        deleteCompanySuccess: false,
      };
    case Actions.DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        deleteCompanySuccess: true,
      };
    case Actions.DELETE_COMPANY_ERROR:
      return {
        ...state,
        deleteError: action.error,
        deleteCompanySuccess: false,
      };
    case Actions.EDIT_COMPANY:
      return {
        ...state,
      };
    case Actions.EDIT_COMPANY_SUCCESS:
      return {
        ...state,
        companyData: action.payload,
      };
    case Actions.EDIT_COMPANY_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case Actions.UPDATE_COMPANY:
      return {
        ...state,
        updateCompanySuccess: false,
      };
    case Actions.UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        updateCompanySuccess: true,
      };
    case Actions.UPDATE_COMPANY_ERROR:
      return {
        ...state,
        updateError: action.error,
        updateCompanySuccess: false,
      };
    default:
      return state;
  }
}
